import CuNotesDeliverResume from './Cu-NotesDeliverResume.vue';
export default CuNotesDeliverResume;


// WEBPACK FOOTER //
// ./src/packages/NotesDeliverResume/CuNotesDeliver/index.js